/** What identifies one installation slot, as the backend serves it. */
export interface SlotIdentity {
  event_id: number;
  slot_key?: string;
}

/**
 * The external id a reservation is held against. The backend serves
 * slot_key, which tells slots apart whichever ids Arrivy is handing out
 * today; a backend that does not serve one is still holding by the bare slot
 * id, so that is the fallback rather than a key it would not recognise.
 */
export const holdExternalId = (slot: SlotIdentity): string => (
  slot.slot_key?.trim() ? slot.slot_key.trim() : String(slot.event_id)
);

/**
 * The id of a slot's button. Arrivy repeats one id across the whole
 * calendar, so the slot key is what keeps these unique on the page.
 */
export const slotDomId = (slot: SlotIdentity): string => (
  `installation_time_${holdExternalId(slot).replace(/:/g, '-')}`
);
